import React from "react"
import PropTypes from "prop-types"
import { Box } from "@mui/material"
import { grey } from "@mui/material/colors"
import GridCell from "./GridCell"
import FooterTextField from "./FooterTextField"
import { useModalPartida } from "hooks/modalPartida/useModalPartida"
import i18n from "i18n"

const RightFooterGrid = ({ currency, bancoDePrecios }) => {
  const {
    state,
    setMarginPercent,
    dispatchMarginPercent,
    dispatchUnitPrice,
    setUnitPrice,
    dispatchMarginEuro,
    setMarginEuro,
    dispatchDiscountPercentage,
    setDiscountPercentage,
  } = useModalPartida()

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gridTemplateRows: "1fr 2fr 2fr",
        width: "100%",
        gap: "4px",
        paddingLeft: "2px",
        paddingRight: "4px",
        paddingBlock: "4px",
        backgroundColor: "#d9d9d9",
        borderBottomRightRadius: "10px",
      }}
    >
      <GridCell col="1 / 3" row="1 / 2" />
      <GridCell col="3 / 5" row="1 / 2">
        {i18n.t("footerGrid.commercialPrice")}
      </GridCell>

      <GridCell col="1 / 2" row="2">
        <GridCell col="1 / 2" row="2">
          <FooterTextField
            value={state.rightFooter.marginPercent}
            label={i18n.t("footerGrid.marginPercent")}
            disabled={!!bancoDePrecios}
            onChange={dispatchMarginPercent}
            onBlur={setMarginPercent}
            suffix="%"
          />
        </GridCell>
      </GridCell>

      <GridCell col="2 / 3" row="2">
        <FooterTextField
          value={state.rightFooter.marginEuro}
          label={i18n.t("footerGrid.margin")}
          onChange={dispatchMarginEuro}
          onBlur={setMarginEuro}
          suffix={currency}
          disabled={!!bancoDePrecios}
        />
      </GridCell>

      <GridCell col="3 / 4" row="2">
        <FooterTextField
          label={i18n.t("footerGrid.unitPrice")}
          value={state.rightFooter.unitPrice}
          onChange={dispatchUnitPrice}
          onBlur={setUnitPrice}
          suffix={currency}
        />
      </GridCell>

      <GridCell col="4 / 5" row="2">
        <FooterTextField
          label={i18n.t("footerGrid.totalPrice")}
          value={state.rightFooter.totalPrice}
          disabled
          suffix={currency}
        />
      </GridCell>

      <GridCell col="1 / 2" row="3">
        <FooterTextField
          label={i18n.t("footerGrid.discountPercent")}
          value={state.rightFooter.discountPercentage}
          onChange={dispatchDiscountPercentage}
          onBlur={setDiscountPercentage}
          suffix="%"
        />
      </GridCell>

      <GridCell col="2 / 3" row="3">
        <FooterTextField
          value={state.rightFooter.discountAmount}
          label={i18n.t("footerGrid.discount")}
          disabled
          suffix={currency}
        />
      </GridCell>

      <GridCell col="3 / 4" row="3">
        <FooterTextField
          label={i18n.t("footerGrid.unitPriceWithDiscount")}
          value={state.rightFooter.unitPriceWithDiscount}
          disabled
          suffix={currency}
        />
      </GridCell>

      <GridCell col="4 / 5" row="3">
        <FooterTextField
          label={i18n.t("footerGrid.totalWithDiscount")}
          value={state.rightFooter.totalPriceWithDiscount}
          disabled
          suffix={currency}
          sx={{ borderBottomRightRadius: "10px" }}
        />
      </GridCell>
    </Box>
  )
}

RightFooterGrid.propTypes = {
  currency: PropTypes.string.isRequired,
  bancoDePrecios: PropTypes.string,
}

export default RightFooterGrid
